<template>
	<div>
		<Loading v-if="loading"/>
		<template v-else>
			<div v-if="transactions.length === 0">{{ noneText }}</div>
			<div v-else class="items-list">
				<ListItem
					v-for="transaction in transactions"
					:key="transaction.id"
					:transaction="transaction"
				/>
			</div>
			<Pagination
				v-model="page"
				:page="page"
				:total="meta.total"
				:items-per-page="itemsPerPage"
				class="mt-4"
				@input="loadTransactions"
			/>
		</template>
	</div>
</template>

<script>
import GetList from "@/api/transaction/GetList";
import Loading from "@/vue/common/Loading";
import ListItem from "./ListItem";
import Pagination from "@/vue/common/Pagination";

export default {

	components: {
		Loading,
		ListItem,
		Pagination,
	},

	props: {
		transactionType: {
			type: String,
			required: false,
		},
		noneText: {
			type: String,
			required: true,
		},
	},

	mounted ()
	{
		this.loadTransactions();
	},

	data ()
	{
		return {
			loading: true,
			page: 1,
			itemsPerPage: 10,
			transactions: null,
			meta: null,
		};
	},

	methods: {
		async loadTransactions ()
		{
			this.loading = true;

			const caller = new GetList()
				.setOffset((this.page - 1) * this.itemsPerPage)
				.setLimit(this.itemsPerPage);

			if (this.transactionType)
			{
				caller.setType(this.transactionType);
			}

			const response = await caller.call();

			this.transactions = response.data;
			this.meta = response.meta;

			this.loading = false;
		}
	}
}
</script>
